"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Notification(props) {
  var i18n = props.i18n,
      notification = props.notification;


  return _react2.default.createElement(
    "div",
    { className: "notification" },
    _react2.default.createElement(
      "div",
      { className: "notification-sub-box" },
      _react2.default.createElement(
        "div",
        { className: "notification-title" },
        _react2.default.createElement(
          "span",
          null,
          i18n.top.notice
        ),
        " ",
        notification.text
      ),
      _react2.default.createElement(
        "div",
        { className: "notification-link" },
        _react2.default.createElement(
          "span",
          null,
          _react2.default.createElement(
            "a",
            { href: notification.pageUrl, target: "_blank", rel: "noopener noreferrer" },
            i18n.top.pleaseClick
          )
        )
      )
    )
  );
} // Notification

Notification.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  notification: _react.PropTypes.object.isRequired
};

exports.default = Notification;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification.js
// module id = 1209
// module chunks = 0